import { render, staticRenderFns } from "./DefectSample.vue?vue&type=template&id=69ca0f04&scoped=true&"
import script from "./DefectSample.vue?vue&type=script&lang=js&"
export * from "./DefectSample.vue?vue&type=script&lang=js&"
import style0 from "./DefectSample.vue?vue&type=style&index=0&id=69ca0f04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ca0f04",
  null
  
)

export default component.exports